import type { Theme } from "@cloudscape-design/components/theming";
import {
  colorBackgroundButtonPrimaryActive,
  colorBackgroundButtonPrimaryDefault,
  colorBackgroundButtonPrimaryHover,
  colorTextButtonPrimaryActive,
  colorTextButtonPrimaryDefault,
  colorTextButtonPrimaryHover,
} from "@amzn/awsui-design-tokens";

const primaryButtonTokens = {
  colorBackgroundButtonPrimaryDefault,
  colorBackgroundButtonPrimaryHover,
  colorBackgroundButtonPrimaryActive,
  colorTextButtonPrimaryDefault,
  colorTextButtonPrimaryHover,
  colorTextButtonPrimaryActive,
};

/**
 * Public Cloudscape primary buttons, themed to match internal Cloudscape.
 *
 * `top-navigation` and `header` set these tokens themselves in the public theme, so a root override alone
 * would leave them blue; internal Cloudscape renders both amber. `alert` and `flashbar` stay blue in both.
 */
export const primaryButtonTheme: Theme = {
  tokens: primaryButtonTokens,
  contexts: {
    "top-navigation": { tokens: primaryButtonTokens },
    header: { tokens: primaryButtonTokens },
  },
};
